import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { CiTimer } from "react-icons/ci";
import { AuthContext } from "../../context/AuthContext";
import Message from "./Message";
import Progress from "./Progress";

const Notifications = () => {
  const { authState } = useContext(AuthContext);
  const [totalCount, setTotalCount] = useState(0);
  const [recentCount, setRecentCount] = useState(0);
  const [contracts, setContracts] = useState([]);

  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/bulk/contracts`,
          {
            headers: {
              "x-auth-token": authState.token,
            },
          }
        );
        const fetchedContracts = response.data;
        console.log("fetched contracts:", fetchedContracts);
        setContracts(fetchedContracts);
      } catch (error) {
        console.error("Error fetching contracts:", error);
        // Handle error appropriately (e.g., show error message)
      }
    };

    fetchContracts();
  }, [authState.token]);

  useEffect(() => {
    // Calculate total count of contracts
    setTotalCount(contracts.length);

    // Calculate count of recently updated contracts (within last 7 days)
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    const recentlyUpdatedCount = contracts.filter((contract) => {
      const updatedAt = new Date(contract.updatedAt);
      return updatedAt >= sevenDaysAgo;
    }).length;

    setRecentCount(recentlyUpdatedCount);
  }, [contracts]);

  return (
    <div>
      <div className="flex flex-col ">
        <Progress />
        <div className="flex flex-col gap-5 m-3 text-indigo-900 dark:text-slate-400">
          <div className="flex gap-4 items-center bg-white dark:bg-slate-900/50 p-2 rounded-md w-full">
            <div className="flex items-center justify-center rounded-full w-8 h-8 bg-indigo-300 dark:bg-slate-950">
              <CiTimer />
            </div>
            <div>
              <div className="font-semibold text-sm">Total Contract Count</div>
              <div>{totalCount}</div>
              <div className="font-semibold text-sm mt-2">
                Recently Updated Contracts
              </div>
              <div>{recentCount}</div>
              <div className="text-indigo-500 text-xs">
                {new Date().toDateString()}
              </div>
            </div>
          </div>
        </div>
        <Message />
      </div>
    </div>
  );
};

export default Notifications;
